/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AccountTypeIEnumerableResponse } from '../models';
import { AppointmentStatusIEnumerableResponse } from '../models';
import { AtcsQuestionTypeIEnumerableResponse } from '../models';
import { BreachIEnumerableResponse } from '../models';
import { BreachTypeIEnumerableResponse } from '../models';
import { CategoryIEnumerableResponse } from '../models';
import { CertifiedTypeIEnumerableResponse } from '../models';
import { ClassificationTypeIEnumerableResponse } from '../models';
import { ContentTypeIEnumerableResponse } from '../models';
import { CorrespondenceDescriptionIEnumerableResponse } from '../models';
import { CorrespondenceTypeIEnumerableResponse } from '../models';
import { EeMembershipTypeIEnumerableResponse } from '../models';
import { EeRequestFormStatusIEnumerableResponse } from '../models';
import { EeRequestFormTypeIEnumerableResponse } from '../models';
import { EeSignUpFormStatusIEnumerableResponse } from '../models';
import { EventTypeIEnumerableResponse } from '../models';
import { FileTypeIEnumerableResponse } from '../models';
import { FollowUpStatusIEnumerableResponse } from '../models';
import { FollowUpTypeIEnumerableResponse } from '../models';
import { InvestigationCategoryIEnumerableResponse } from '../models';
import { InvestigationStatusIEnumerableResponse } from '../models';
import { LeaveTypeIEnumerableResponse } from '../models';
import { NotesTypeIEnumerableResponse } from '../models';
import { PracticeRiskIEnumerableResponse } from '../models';
import { PracticeRiskIndicatorIEnumerableResponse } from '../models';
import { PriorityIEnumerableResponse } from '../models';
import { ReportResultIEnumerableResponse } from '../models';
import { Request } from '../models';
import { SignatoryTypeIEnumerableResponse } from '../models';
import { SolelyJointlyIEnumerableResponse } from '../models';
import { StatusIEnumerableResponse } from '../models';
import { SuburbStatePostcodeIEnumerableResponse } from '../models';
import { TimeEntryActivityIEnumerableResponse } from '../models';
import { TimeEntryStatusIEnumerableResponse } from '../models';
import { TimeEntryTypeIEnumerableResponse } from '../models';
import { TimesheetStatusIEnumerableResponse } from '../models';
import { TrustAccountStatusIEnumerableResponse } from '../models';
import { UserGroupIEnumerableResponse } from '../models';
/**
 * CodeApi - axios parameter creator
 * @export
 */
export const CodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Account Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAccountTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetAccountTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Appointment Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAppointmentStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetAppointmentStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Atcs Question Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAtcsQuestionTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetAtcsQuestionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Breach Types - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetBreachTypesPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetBreachTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Breaches - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetBreachesPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetBreaches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCategoriesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All| Returns Certified Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCertifiedTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetCertifiedTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetClassificationTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetClassificationTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Content Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetContentTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetContentTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All| Returns Correspondence Descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCorrespondenceDescriptionsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetCorrespondenceDescriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Correspondence Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCorrespondenceTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetCorrespondenceTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeMembershipTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetEeMembershipTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeRequestFormStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetEeRequestFormStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeRequestFormTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetEeRequestFormTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner SignUp Form Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeSignUpFormStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetEeSignUpFormStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Event Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEventTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetEventTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFileTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetFileTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFollowUpStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetFollowUpStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFollowUpTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetFollowUpTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Invetigation Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetInvestigationCategoryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetInvestigationCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetInvestigationStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetInvestigationStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TIP All | Returns Leave Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLeaveTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetLeaveTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Note Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetNoteTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetNoteTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Practice Risk Indicators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPracticeRiskIndicatorsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetPracticeRiskIndicators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Practice Risks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPracticeRisksGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetPracticeRisks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Priorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPrioritiesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetPriorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All| Returns Report Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetReportResultsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetReportResults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Routine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetRoutineStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetRoutineStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSignatoryTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetSignatoryTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Solely/Jointly
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSolelyJointliesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetSolelyJointlies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary READER | Returns Suburbs, States, and Postcode
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSuburbStatePostcodePost: async (body?: Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetSuburbStatePostcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryActivitiesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimeEntryActivities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entry Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimeEntryStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimeEntryTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Timesheet Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimesheetStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTimesheetStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Practice Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTrustAccountStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetTrustAccountStatuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns User Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetUserGroupsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Code/GetUserGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeApi - functional programming interface
 * @export
 */
export const CodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Account Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetAccountTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetAccountTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Appointment Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetAppointmentStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppointmentStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetAppointmentStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Atcs Question Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetAtcsQuestionTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AtcsQuestionTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetAtcsQuestionTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Breach Types - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetBreachTypesPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreachTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetBreachTypesPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Atcs_All | Returns Breaches - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetBreachesPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreachIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetBreachesPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetCategoriesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetCategoriesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All| Returns Certified Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetCertifiedTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CertifiedTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetCertifiedTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetClassificationTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassificationTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetClassificationTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Content Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetContentTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetContentTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All| Returns Correspondence Descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetCorrespondenceDescriptionsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorrespondenceDescriptionIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetCorrespondenceDescriptionsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Correspondence Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetCorrespondenceTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorrespondenceTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetCorrespondenceTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetEeMembershipTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeMembershipTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetEeMembershipTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetEeRequestFormStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeRequestFormStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetEeRequestFormStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetEeRequestFormTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeRequestFormTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetEeRequestFormTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns External Examiner SignUp Form Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetEeSignUpFormStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EeSignUpFormStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetEeSignUpFormStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Event Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetEventTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetEventTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetFileTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetFileTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetFollowUpStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowUpStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetFollowUpStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetFollowUpTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FollowUpTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetFollowUpTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Invetigation Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetInvestigationCategoryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationCategoryIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetInvestigationCategoryGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetInvestigationStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetInvestigationStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TIP All | Returns Leave Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetLeaveTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetLeaveTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Note Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetNoteTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetNoteTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Practice Risk Indicators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetPracticeRiskIndicatorsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeRiskIndicatorIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetPracticeRiskIndicatorsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Practice Risks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetPracticeRisksGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PracticeRiskIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetPracticeRisksGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Priorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetPrioritiesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriorityIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetPrioritiesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All| Returns Report Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetReportResultsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportResultIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetReportResultsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Routine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetRoutineStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetRoutineStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetSignatoryTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetSignatoryTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Solely/Jointly
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetSolelyJointliesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolelyJointlyIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetSolelyJointliesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary READER | Returns Suburbs, States, and Postcode
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetSuburbStatePostcodePost(body?: Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuburbStatePostcodeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetSuburbStatePostcodePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimeEntryActivitiesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryActivityIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimeEntryActivitiesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Time Entry Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimeEntryStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimeEntryStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimeEntryTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryTypeIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimeEntryTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Timesheet Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTimesheetStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimesheetStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTimesheetStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Trust Practice Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetTrustAccountStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrustAccountStatusIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetTrustAccountStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns User Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2CodeGetUserGroupsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupIEnumerableResponse>> {
            const localVarAxiosArgs = await CodeApiAxiosParamCreator(configuration).apiV2CodeGetUserGroupsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CodeApi - factory interface
 * @export
 */
export const CodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Account Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAccountTypesGet(options?: any): AxiosPromise<AccountTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetAccountTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Appointment Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAppointmentStatusesGet(options?: any): AxiosPromise<AppointmentStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetAppointmentStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Atcs_All | Returns Atcs Question Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetAtcsQuestionTypesGet(options?: any): AxiosPromise<AtcsQuestionTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetAtcsQuestionTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Atcs_All | Returns Breach Types - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetBreachTypesPost(options?: any): AxiosPromise<BreachTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetBreachTypesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Atcs_All | Returns Breaches - ATCS only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetBreachesPost(options?: any): AxiosPromise<BreachIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetBreachesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCategoriesGet(options?: any): AxiosPromise<CategoryIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All| Returns Certified Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCertifiedTypesGet(options?: any): AxiosPromise<CertifiedTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetCertifiedTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Classification Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetClassificationTypesGet(options?: any): AxiosPromise<ClassificationTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetClassificationTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Content Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetContentTypesGet(options?: any): AxiosPromise<ContentTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetContentTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All| Returns Correspondence Descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCorrespondenceDescriptionsGet(options?: any): AxiosPromise<CorrespondenceDescriptionIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetCorrespondenceDescriptionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Correspondence Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetCorrespondenceTypesGet(options?: any): AxiosPromise<CorrespondenceTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetCorrespondenceTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns External Examiner Membership Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeMembershipTypesGet(options?: any): AxiosPromise<EeMembershipTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetEeMembershipTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeRequestFormStatusesGet(options?: any): AxiosPromise<EeRequestFormStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetEeRequestFormStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns External Examiner Request Form Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeRequestFormTypesGet(options?: any): AxiosPromise<EeRequestFormTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetEeRequestFormTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns External Examiner SignUp Form Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEeSignUpFormStatusesGet(options?: any): AxiosPromise<EeSignUpFormStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetEeSignUpFormStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Event Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetEventTypesGet(options?: any): AxiosPromise<EventTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetEventTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reader | Returns File Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFileTypesGet(options?: any): AxiosPromise<FileTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetFileTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFollowUpStatusesGet(options?: any): AxiosPromise<FollowUpStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetFollowUpStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Follow Up Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetFollowUpTypesGet(options?: any): AxiosPromise<FollowUpTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetFollowUpTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Invetigation Categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetInvestigationCategoryGet(options?: any): AxiosPromise<InvestigationCategoryIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetInvestigationCategoryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetInvestigationStatusesGet(options?: any): AxiosPromise<InvestigationStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetInvestigationStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TIP All | Returns Leave Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetLeaveTypesGet(options?: any): AxiosPromise<LeaveTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetLeaveTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Note Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetNoteTypesGet(options?: any): AxiosPromise<NotesTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetNoteTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Practice Risk Indicators
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPracticeRiskIndicatorsGet(options?: any): AxiosPromise<PracticeRiskIndicatorIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetPracticeRiskIndicatorsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Practice Risks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPracticeRisksGet(options?: any): AxiosPromise<PracticeRiskIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetPracticeRisksGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Priorities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetPrioritiesGet(options?: any): AxiosPromise<PriorityIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetPrioritiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All| Returns Report Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetReportResultsGet(options?: any): AxiosPromise<ReportResultIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetReportResultsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Routine Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetRoutineStatusesGet(options?: any): AxiosPromise<InvestigationStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetRoutineStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Signatory Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSignatoryTypesGet(options?: any): AxiosPromise<SignatoryTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetSignatoryTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Solely/Jointly
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSolelyJointliesGet(options?: any): AxiosPromise<SolelyJointlyIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetSolelyJointliesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetStatusGet(options?: any): AxiosPromise<StatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary READER | Returns Suburbs, States, and Postcode
         * @param {Request} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetSuburbStatePostcodePost(body?: Request, options?: any): AxiosPromise<SuburbStatePostcodeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetSuburbStatePostcodePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Activities
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryActivitiesGet(options?: any): AxiosPromise<TimeEntryActivityIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimeEntryActivitiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Time Entry Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryStatusesGet(options?: any): AxiosPromise<TimeEntryStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimeEntryStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TIP All | Returns Time Entry Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimeEntryTypesGet(options?: any): AxiosPromise<TimeEntryTypeIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimeEntryTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Timesheet Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTimesheetStatusesGet(options?: any): AxiosPromise<TimesheetStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTimesheetStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Trust Practice Statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetTrustAccountStatusesGet(options?: any): AxiosPromise<TrustAccountStatusIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetTrustAccountStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns User Groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2CodeGetUserGroupsGet(options?: any): AxiosPromise<UserGroupIEnumerableResponse> {
            return CodeApiFp(configuration).apiV2CodeGetUserGroupsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodeApi - object-oriented interface
 * @export
 * @class CodeApi
 * @extends {BaseAPI}
 */
export class CodeApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Account Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetAccountTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetAccountTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Appointment Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetAppointmentStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetAppointmentStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Atcs_All | Returns Atcs Question Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetAtcsQuestionTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetAtcsQuestionTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Atcs_All | Returns Breach Types - ATCS only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetBreachTypesPost(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetBreachTypesPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Atcs_All | Returns Breaches - ATCS only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetBreachesPost(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetBreachesPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetCategoriesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All| Returns Certified Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetCertifiedTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetCertifiedTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Classification Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetClassificationTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetClassificationTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Content Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetContentTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetContentTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All| Returns Correspondence Descriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetCorrespondenceDescriptionsGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetCorrespondenceDescriptionsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Correspondence Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetCorrespondenceTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetCorrespondenceTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns External Examiner Membership Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetEeMembershipTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetEeMembershipTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns External Examiner Request Form Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetEeRequestFormStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetEeRequestFormStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns External Examiner Request Form Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetEeRequestFormTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetEeRequestFormTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns External Examiner SignUp Form Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetEeSignUpFormStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetEeSignUpFormStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Event Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetEventTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetEventTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Reader | Returns File Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetFileTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetFileTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Follow Up Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetFollowUpStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetFollowUpStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Follow Up Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetFollowUpTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetFollowUpTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Invetigation Categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetInvestigationCategoryGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetInvestigationCategoryGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetInvestigationStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetInvestigationStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TIP All | Returns Leave Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetLeaveTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetLeaveTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Note Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetNoteTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetNoteTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Practice Risk Indicators
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetPracticeRiskIndicatorsGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetPracticeRiskIndicatorsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Practice Risks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetPracticeRisksGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetPracticeRisksGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Priorities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetPrioritiesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetPrioritiesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All| Returns Report Results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetReportResultsGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetReportResultsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Routine Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetRoutineStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetRoutineStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Signatory Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetSignatoryTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetSignatoryTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Solely/Jointly
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetSolelyJointliesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetSolelyJointliesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetStatusGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetStatusGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary READER | Returns Suburbs, States, and Postcode
     * @param {Request} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetSuburbStatePostcodePost(body?: Request, options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetSuburbStatePostcodePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TIP All | Returns Time Entry Activities
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimeEntryActivitiesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimeEntryActivitiesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Time Entry Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimeEntryStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimeEntryStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TIP All | Returns Time Entry Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimeEntryTypesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimeEntryTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Timesheet Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTimesheetStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTimesheetStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Trust Practice Statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetTrustAccountStatusesGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetTrustAccountStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns User Groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public apiV2CodeGetUserGroupsGet(options?: any) {
        return CodeApiFp(this.configuration).apiV2CodeGetUserGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
